import { httpsCallable } from "firebase/functions";
export class UserAccountsApiService {
    constructor(functions) {
        this.functions = functions;
    }
    async getAccounts() {
        try {
            const getUserAccount = httpsCallable(this.functions, 'getUserAccount');
            const result = await getUserAccount();
            const response = result.data;
            console.log("firebaseFunctionsApi.getAccounts response:", response);
            return response;
        }
        catch (e) {
            console.error("UserAccountsApi.getAccounts error:", e);
            return undefined;
        }
    }
}
